

export const recruitInit = (move) => {
    // console.log(move)

    if (document.body.classList.contains("recruit")) {
        //video
        if (document.querySelector(".video>video")) {
            let video = document.querySelector(".video>video")
            videomover()

            window.addEventListener("scroll", videomover)

            function videomover() {
                let p = (scrollY / (innerHeight + innerWidth * 0.690972222222)) * 13.75
                if (p <= 12.5) {
                    video.style.clipPath = `polygon(${p}% ${p}%,${100 - p}% ${p}%,${100 - p}% ${100 - p}%,${p}% ${100 - p}%)`
                    video.parentNode.style.display = "block"
                } else if (p > 12.5) {
                    video.parentNode.style.display = "none"
                } else if (p < 0) {
                    video.parentNode.style.display = "none"
                }
            }
        }

        //job scroll
        const job = document.querySelector(".job")
        const jobBlock = job.querySelector(".job__innerBlock")
        const jobcrnt = job.querySelector(".job__innerBlockScrollCrnt")
        const slides = job.querySelectorAll(".swiper-slide")
        let prevInnerWidth = innerWidth

        let height = 0
        let slideLen, originalHeight, swiperHeight

        onresize()
        onscroll()

        window.addEventListener("scroll", onscroll)

        let timeoutId = 0;

        window.addEventListener('resize', decideResize);

        function onscroll() {
            if (window.barbaInfo.move == move) {
                if (document.body.classList.contains("recruit") && job.getBoundingClientRect().top <= innerHeight + innerHeight / 2 && job.getBoundingClientRect().bottom >= -innerHeight / 2) {
                    let offset = 0
                    if (innerWidth > 1024) {
                        offset = originalHeight + height * 1.5
                    } else {
                        offset = originalHeight
                    }
                    let p = (-job.getBoundingClientRect().top - offset) / (swiperHeight)
                    let percent = (p / (7 / 100) + 7) / 2

                    if (percent >= 0 && percent <= slideLen) {
                        jobcrnt.style.height = `${percent / slideLen * 100}%`
                    } else if (percent < 0) {
                        jobcrnt.style.height = `0%`
                    } else if (percent > slideLen) {
                        jobcrnt.style.height = `100%`
                    }

                    let jobBlockInfo = jobBlock.getBoundingClientRect()

                    if (jobBlockInfo.top + jobBlockInfo.height / 2 <= innerHeight / 2 + 1) {
                        job.classList.add("afterJobTtl")
                    } else {
                        job.classList.remove("afterJobTtl")
                    }

                    if (window.swiper.job) {
                        jobcrnt.querySelector("p").innerHTML = Math.min(Math.max(window.swiper.job.realIndex + 1, 1), slideLen)
                        if (window.swiper.job.realIndex != Math.floor(percent)) {
                            window.swiper.job.realIndex = Math.floor(percent)
                            window.swiper.job.slideTo(Math.floor(percent))
                            // console.log("page changed")
                        }
                    }
                }
            }
        }

        function decideResize() {
            if (window.barbaInfo.move == move) {
                if (prevInnerWidth != innerWidth) {
                    if (timeoutId) clearTimeout(timeoutId);
                    timeoutId = setTimeout(onresize, 500);
                }
            }
        }

        function onresize() {
            height = 0
            slides.forEach((slide) => {
                height = height < slide.getBoundingClientRect().height ? slide.getBoundingClientRect().height : height
            })

            if (innerWidth > 1024) {
                height = height * 3
            }

            slideLen = slides.length

            job.style.height = "auto"
            originalHeight = job.getBoundingClientRect().height
            swiperHeight = height * (slideLen - 1)
            if (innerWidth > 1024) {
                job.style.height = swiperHeight + "px"
            } else {
                job.style.height = job.getBoundingClientRect().height + swiperHeight + "px"
            }
        }
    }
}